import { Resolvers } from '@apollo/client'

const resolvers: Resolvers = {
  User: {
    fullName: (user) => user && `${user.firstName} ${user.lastName}`.trim(),
  },
}

export default resolvers
